/* eslint-disable @typescript-eslint/no-explicit-any */
const Precio = ({ setForm, form }: any) => {
  const days = ["LU", "MA", "MI", "JU", "VI", "SA", "DO"];

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, value: any) => {
    switch (e.target.name) {
      case "price":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "prices-guests":
        {
          let prices = form.PRICES;
          prices[value]["guests"] = e.target.value;
          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      case "prices-price":
        {
          let prices = form.PRICES;
          prices[value]["price"] = e.target.value;
          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: React.ChangeEvent<HTMLInputElement>, value: any) => {
    switch (e.target.name) {
      case "prices-day":
        {
          let prices = form.PRICES;
          let days = prices[value.index]["day"].split(",");



          if (days.indexOf(value.value) == -1) {
            days.push(value.value);
            days = days.filter((d: any) => d !== '');
            prices[value.index]["day"] = days.join(",");
          } else {
            delete days[days.indexOf(value.value)];
            days = days.filter((d: any) => d != null);
            days = days.filter((d: any) => d !== '');
            prices[value.index]["day"] = days.join(",");
          }

          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      case "remove":
        {
          let prices = form.PRICES;
          delete prices[value];
          prices = prices.filter((p: any) => p != null);

          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      case "add":
        {
          const price = {
            day: "LU,MA,MI,JU,VI,SA,DO",
            name: "",
            description: "",
            guests: null,
            price: 0,
          };

          let prices = form.PRICES;
          prices.push(price);

          setForm({
            ...form,
            PRICES: prices,
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className=" flex justify-center items-center">
      <div className="grid lg:grid-cols-1 gap-5 py-5 px-5">
        <div className="p-4 ">
          <span className="font-bold text-primary mb-1 block">
            Ahora, fijá tu precio
          </span>
          <span className="block">Podés cambiarlo cuando quieras.</span>

          <input
            type="text"
            className="border-0 w-full text-6xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
            value={form.price}
            name="price"
            onChange={(event) => onChange(event, null)}
          />

          <span className="block">
            Precio para huésped (Con impuestos): ${parseFloat(form.price) + (form.price / 100 * 20) }
          </span>
        </div>
        <div className="p-4">
          <label className="cursor-pointer flex">
            <i className="bi bi-plus text-white rounded-full bg-primary  w-[30px] h-[30px] flex items-center justify-center me-1"></i>
            Agregar nuevo precio personalizado
            <button
              className="hidden"
              name="add"
              onClick={(e: any) => onClick(e, null)}
            ></button>
          </label>
        </div>

        {form.PRICES.map((price: any, index: number) => {
          return (
            <div className="mb-2 border p-4">
              <span className="font-bold text-primary mb-1 block">
                Precio personalizado
              </span>
              <span className="block">Podés cambiarlo cuando quieras.</span>
              <input
                type="text"
                className="border-0 w-full text-5xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
                value={price.price}
                name="prices-price"
                onChange={(event) => onChange(event, index)}
              />
              <span className="block">
                Precio para huésped (Con impuestos): ${parseFloat(price.price) + (price.price / 100 * 20) }
              </span>
              <div className="mb-3">
                <span className="block">
                  Mostrar a partir de cuantos huespedes
                </span>
                <input
                  type="text"
                  className="w-full border
            text-3xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
                  value={price.guests}
                  name="prices-guests"
                  onChange={(event) => onChange(event, index)}
                />
              </div>
              <div className="mb-5">
                <span className="block mb-3">
                  Mostrar solo algunos dias de la semana
                </span>
                <div>
                  {days.map((day) => {
                    return (
                      <label
                        className={`cursor-pointer font-bold p-3 rounded-md me-1 ${
                          price.day.includes(day) 
                            ? "bg-primary text-white "
                            : "border hover:bg-primary hover:text-white"
                        }`}
                      >
                        {day}
                        <button
                          className="hidden"
                          name="prices-day"
                          onClick={(e: any) =>
                            onClick(e, { index: index, value: day })
                          }
                        ></button>
                      </label>
                    );
                  })}
                </div>
              </div>
              <div className="">
                <label className="cursor-pointer flex border-0 rounded-xl p-2">
                  <i className="bi bi-x-lg text-white rounded-full bg-primary text-[10px]  w-[30px] h-[30px] flex items-center justify-center me-1"></i>
                  Quitar precio personalizado
                  <button
                    className="hidden"
                    name="remove"
                    onClick={(e: any) => onClick(e, index)}
                  ></button>
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Precio;
